export default {
  paidOut: "(Uitbetaald)",
  product: "Produkt",
  quantity: "Menge",
  attributes: "Attribute",
  points: "Punkte",
  point: "Punkt",
  action: "Aktion",
  clear: "Löschen",
  back: "Zurück",
  save: "Speichern",
  close: "Schließen",
  of: "Von",
  to: "Bis",
  copyrights: "© {date} Bridgestone Solutions. All rights reserved.",
  pageNotFound: "Seite nicht gefunden",
  accessDenied: "Zugriff abgelehnt",
  search: "Suche",
  dashboard: {
    profile: {
      welcome: "Willkommen",
      completeProfile: "Persönliches Profil vervollständigen und zusätzlich",
      completeProfileBold: "200 Punkte sichern.",
      link: "Profil anzeigen",
      fullCompleteProfile: "Ihr persönliches Profil ist vollständig! ",
    },
    pobox: {
      newMessages: "Neue Nachrichten in Ihrem Postfach",
      link: "Nachrichten anzeigen",
    },
    bankstatement: {
      yourScore: "Ihr aktueller Punktestand:",
      lastUpdate: "Letzte Aktualisierung:",
      link: "Punkteübersicht anzeigen",
      kickbackLink: "Übersicht über die Kickback-Gebühren",
      yourKickback: "Ihre aktuelle Anzahl an Kickback-Gebühren:",
    },
    showAllProducts: "Zum Prämienshop",
  },
  pageName: {
    productInfoAndQuestions: "Produktinformationen UND Freigaben",
    preislisten: "Produktinformationen",
    preislistenList: "Preislisten",
    dashboard: "Hauptseite",
    trainings: "Trainings",
    onlineTrainings: "Online-Trainings",
    bridgestoneSchulungen: "Bridgestone Schulungen",
    shop: "Prämienshop",
    shopProducts: "Prämienshop",
    shopCategory: "Prämienshop",
    product: "Produkt",
    productDetails: "Produktdetails",
    productInfo: "Produktinformationen",
    pkw: "Pkw",
    motorrad: "Motorrad",
    lkwUndBusse: "Lkw und Busse",
    produktbroschuren: "Produktbroschüren",
    pricat: "Pricat",
    landwirtschaft: "Landwirtschaft",
    baumaschinenOtr: "Baumaschinen - Otr",
    bDrive: "Produktabbildungen",
    beanstandungsFormular: "Beanstandungsformular",
    bridgestoneProduktbroschuren: "Bridgestone Produkte",
    firestoneProduktbroschuren: "Firestone Produkte",
    technologien: "Technologien, Markierungen und mehr",
    training: "Training",
    trainingForm: "Training form",
    account: "Mein Konto",
    pointsOverview: "Mein Punktekonto",
    stammdaten: "Meine Stammdaten",
    mailbox: "Postfach",
    singleMailbox: "Nachricht",
    bridgestoneSingleSchulungen: "Bridgestone Schulungen Training",
    externeTraining: "Externe Schulungen",
    warenkorb: "Warenkorb",
    orderSummary: "Bestellübersicht",
    orderDelivery: "Lieferadresse",
    orderComplete: "Bestellung erfolgreich",
    text_page: "Statische Seite",
    contact_service: "Kontakt & Service",
    sales_support: "Verkaufsunterstützung",
    salesPromotions: "Verkaufsförderung",
    productInfoAndPriceList: "Produktinformationen & Preislisten",
    service_number: "Service-Nummern",
    about: 'Über Bridgestone <span class="text-danger">Plus</span>',
    contact_form: "Beanstandungsformular",
    userOrders: "Meine Bestellungen",
    userOrder: "Deine Bestellung",
    hunterShop: "Hunter",
    wholesaler: "Dashboard strategischer Partner",
    news_feeds: "Aktuelles",
    investment: "Investitionsunterstützung",
    staff: "Dashboard",
    fuelCalculator: "Spritspar-Rechner",
    myAccount: "Ihre Konto",
    myPoints: "Meine Reifenbestellungen",
    commitmentLetter: "Commitment letter",
    rewardsOverview: "Erläuterung der Kickback-Gebühr und der Punkte",
    strategic_partners: "Kontakt zum Vertriebspartner",
    onlineVisibility: "Uberall",
    media: "Medienbibliothek",
    medias: "Medienbibliothek",
    first_stop: "Garantie für Bridgestone-Reifen",
    staffVouchers: "Vouchercodes",
    wholesalerVouchers: "Vouchercodes",
    brochure_prices: "Produktbroschüren & Preislisten",
    touch_incentive: "Contact Touch Incentive",
    favoriteProducts: "Lieblingsprodukte",
    onlineTrainingCategory: "Online trainings",
    onlineTrainingCategoryType: "Online trainings",
  },
  account: {
    title: "Mein Konto",
    desc: "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihre Stammdaten ergänzen oder  anpassen, Ihr Postfach und Ihren Punkte-Kontosauszug einsehen.",
    descStaff:
      "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihre Stammdaten ergänzen oder  anpassen, Ihr Postfach und Ihren Punkte-Kontosauszug einsehen.",
    categories: {
      basedata: {
        title: "Stammdaten",
        desc: "Vervollständigen Sie hier Ihre Kontakt- und Unternehmensdaten für eine erfolgreiche Teilnamhme.",
      },
      pobox: {
        title: "Postfach",
        desc: "Wichtige Nachrichten, Bestellbestätigungen und Neuigkeiten finden Sie in Ihrem persönlichen Postfach.",
      },
      bankstatement: {
        title: "Kontoauszug",
        desc: "Hier können Sie Ihren aktuellen Prämienpunktestand und die Kontobewegungen einsehen.",
      },
    },
  },
  profile: {
    title: "Meine Stammdaten",
    description:
      "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihre Stammdaten ergänzen oder anpassen, Ihr Postfach und Ihren Punkte-Kontosauszug einsehen.",
    personalData: "Persönliche daten",
    password: "Passwort",
    password1: "Passwort (frei wählbar)*",
    password2: "Passwort (Wiederholung)*",
    formOfAddress: "Anrede",
    choose: "Bitte wählen",
    mr: "Herr",
    mrs: "Frau",
    diverse: "Diverse",
    firstname: "Vorname",
    surname: "Nachname",
    position: "Position im betrieb",
    operatingData: "Betriebsdaten",
    company: "Firma",
    legalForm: "Rechtsform",
    name: "Name",
    streetHouseNr: "Straße und Hausnr.",
    street: "Straße",
    postcode: "PLZ",
    location: "ORT",
    country: "Land",
    de: "Deutschland",
    at: "Österreich",
    ch: "Schweiz",
    nl: "Niederlande",
    it: "Italien",
    language: "Sprache",
    french: "Französisch",
    italian: "Italienisch",
    german: "Deutschland",
    nederland: "Niederlande",
    phone: "Telefon",
    website: "Webseite",
    operatingIndicators: "Betriebskennzahlen",
    tireSale: "Reifenumsatz pro Jahr ca. in Stk.",
    tireSaleLabel: "Verkaufen Sie Reifen in großen Mengen",
    inches: "Davon ≥ 18 Zoll (in %)",
    inchesLabel: "Davon 18 Zoll und größer in %",
    segmentSale:
      "Reifenabsatz nach segmenten (Anteil Budget / Mid / Premium in %)",
    premBudget: "Premium",
    midBudget: "Mid",
    budBudget: "Budget",
    distribution: "VERTEILUNG SOMMER / WINTER / ALL SEASON (in %)",
    tyreSizes: "Anzahl einlagerungen pro saison (Reifensätze)",
    diffDeliveryAddres: "Lieferadresse hinzufügen",
    yourEmailAddress: "Ihre E-Mail Adresse*",
    clientNr: "Kundennummern",
    clientNrSingular: "Kundennummer",
    clientNrContent:
      "<span class='text-danger fw-bold'>WICHTIG - BITTE LESEN:</span><br /><br /> Für die Zuordnung Ihrer Reifenbestellungen beim Großhandel und / oder bei Bridgestone ist es <b>zwingend erforderlich, dass Sie Ihre jeweiligen Kundenummern angeben.</b>Sollten Sie <b>mehrere Kundennummern bei einem Großhändler und / oder bei Bridgestone haben,</b> z. B. für Ihr Hauptgeschäft und Ihre Filialen, geben Sie zuerst die Kundennummer des Hauptgeschäftes an.<b>Die Umsätze der weiteren Kundennummern werden dann Ihrem Hauptgeschäft zugeordnet.</b>",
    supplySource: "Bezugsquelle",
    email: "E-Mail Adresse",
    staffEmail: "Teilnehmer E-Mail adresse",
    registered: "Registriert am",
    registeredAt: "Registriert am",
    lastLogIn: "Letzer Log-in",
    details: "Details",
    inDetail: "{name} im Detail",
    bsClientNr: "Ihre Bridgestone Kundennummer",
    bftClientNr: "Ihre Best4Tires Kundennummer",
    acceptTerms: "AGB und Teilnahmebedingungen aktzeptieren.",
    newCustomerNumbersInfo:
      "<span class='text-danger fw-bold'>WICHTIG - BITTE LESEN:</span><br />Bei erstmaliger Angabe der Kundennummer werden Ihre Angaben auf deren Richtigkeit und hinsichtlich unserer vertrieblichen Kriterien überprüft. Die Entscheidung über eine Freischaltung der Kundennummer(n) und Verknüpfung mit Ihrem Profil kann bis zu 5 Arbeitstage in Anspruchnehmen.",
    selectWholeSaler: "bei Lieferant (bitte eintragen)",
    cooperation: "MITGLIED / KOOPERATION",
    error100: "Die Summe der Werte muss 100% betragen.",
    errorRange: "Der Wert muss zwischen 0 und 100 liegen",
    btw_number_label: "Umsatzsteuer-Identifikationsnummer Ihres Unternehmens",
    btw_number: "Umsatzsteuer-Identifikationsnummer",
    mobile: "HANDYNUMMER",
    mobile_label: "Ihre (Mobil-)Telefonnummer",
    iban_number: "IBAN-Nummer IHRES UNTERNEHMENS",
    iban_number_label: "IBAN-nummer",
    yourCsNr: "Ihre Kundennummern",
    yourLastName: "Ihr Nachname",
    positionLabel: "Position auswählen",
    yourFirstName: "Ihr Vorname",
    companyLabel: "Firma",
    numberOfSetsOfSeasonalTiresBudget: "Einlagerungen pro Jahr",
    tireSaleDetail: "Reifenverkäufe pro Jahr",
    contactInfo: "Bei Rückfragen wenden Sie sich bitte an:",
  },
  pobox: {
    title: "Mein Postfach",
    desc: "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihre Stammdaten ergänzen oder anpassen, Ihr Postfach und Ihren Punkte-Kontosauszug einsehen.",
    message: {
      sender: "Absender",
      thread: "Betreff",
    },
    sender: {
      system: "BRIDGESTONE PLUS",
    },
    back: "Zurück zur Übersicht",
  },
  time: {
    secondsAgo: "vor {time} Sekunden",
    minutesAgo: "vor {time} Minuten",
    hoursAgo: "vor {time} Stunden",
    daysAgo: "vor {time} Tagen",
  },
  bankstatement: {
    title: "Mein persönlicher Kontoauszug",
    desc: "Hier können Sie Ihren persönlichen Bridgestone Plus Kontoauszug zu Ihren erhaltenen und verwendeten Prämienpunkten einsehen. Bitte beachten Sie, dass Punktegutschriften für Ihre Reifenorder je nach Bezugsquelle erst nach bis zu 6 Wochen nach Orderzeitpunkt gutgeschrieben werden.",
    score: "Punktestand",
    regularPoints: "Reguläre Punkte",
    boosterPoints: "Booster Punkte",
    date: "Datum",
    supplySourceReason: "Bezugsquelle / Grund",
    article: "Artikel",
    brand: "Marke",
    product: "Produkt",
    type: "Typ",
    inch: "Zoll",
    season: "Saison",
    amount: "Menge",
    standardPoints: "Punkte",
    boosterProduct: "Booster Produkt",
    boosterSeason: "Booster Saison",
    otherActions: "Sonstige Handlung bzw. Ursache",
    totalPoints: "Punkte Gesamt",
    income: "Zugänge",
    spending: "Abgänge",
    lastMonth: "Stand Ende",
    loadMore: "Weitere umsätze laden",
    typeFilter: "Filtern nach Bezugsquelle",
    dateFilter: "Filtern nach Datumsbereich",
    customer_number: "Kdnr.",
    currentPoints: "Aktuelle Punkte",
    calculationDate: "Berechnungsdatum",
    positivePoints: "Positive Punkte",
    negativePoints: "Bereits ausgegeben",
    tyresAmount: "Reifen Menge jährlich",
    pointsTotal: "Gesamtpunktzahl",
    currentPointState: "Aktueller Punktestand",
    currentKickbackState: "Aktueller kickback",
    pointsFromCurrentYear: "Zugang: Punkte aus dem aktuellen Jahr ({year})",
    pointsAtRiskOfExpiry: "Auszugebende Punkte bis 31.03.{year}",
  },
  shop: {
    variant: "Varianten wählbar",
    description:
      "Herzlich willkommen im Prämienshop. Hier können Sie Ihre Bridgestone Plus Punkte  gegen Prämien aus verschiedenen Kategorien einlösen. Das Angebot an Produkten  wird regelmäßig aktualisiert. Wir wünschen viel Spaß beim Stöbern.",
    selectedProducts: "Ausgewählte Produkte",
    selectedAddress: "Ausgewählte Adresse",
    noProducts: "Die Suchkriterien ergaben keine Treffer",
    placeOrder: "Verbindlich Bestellen",
    toOrderDelivery: "Weiter zur Lieferadresse",
    toOrderSummary: "Zur Bestellübersicht",
    emptyCart: "Warenkorb ist leer.",
    pointsTotal: "Punkte insgesamt",
    productImg: "Produktbild",
    selectAddressBtn: "Adresse auswählen",
    selectAddressP: "Bitte wählen Sie Ihre Lieferadresse aus",
    notEnoughPoints: "Nicht genügend Punkte vorhanden.",
    outOfStock: "Derzeit nicht auf Lager",
    timeUnavailable: "Zur Zeit nicht lieferbar",
    productUnavailable: "Dieses Produkt ist nicht mehr verfügbar.",
    deletedProductsTitle: "Produkte nicht mehr verfügbar",
    deletedProductsMessage:
      "Die folgenden Produkte sind nicht mehr verfügbar. Bitte entfernen Sie sie aus dem Warenkorb, um fortzufahren.",
    removeSelected: "Auswahl entfernen",
    clearCart: "Warenkorb leeren",
    removeSelectedConfirm: "Die ausgewählten Produkte aus dem Warenkorb entfernen?",
    clearCartConfirm: "Alle Produkte aus dem Warenkorb entfernen?",
    cart: {
      pointsPerUnit: "Punkte / Einheit",
      pointsSum: "Punkte",
    },
    sort: {
      asc: "Sortieren nach: Niedrigster Preis",
      desc: "Sortieren nach: Höchster Preis",
    },
    perPgae: "Elemente pro Seite",
    categories: {
      advertising: {
        title: "Werbemittel",
        desc: "Direkt hier auf der Plattform teilnehmen und  40 Extrapunkte für den Prämienclub sichern.",
      },
      rewards: {
        title: "Exklusiv-Prämien",
        desc: "Entdecken Sie das Pramienangebot in unserem Trainingscenter oder bei Ihnen vor Ort.",
      },
      tools: {
        title: "Werkstatt-Tools",
        desc: "Setzen Sie Ihre Punkte für Drittanbieter-  Trainings ein und reduzieren Sie so Ihre Kosten.",
      },
      trainings: {
        title: "Trainings & Schulungen",
        desc: "Entdecken Sie das Prämienangebot in unserem Trainingscenter oder bei Ihnen vor Ort.",
      },
      salesroom: {
        title: "Verkaufsraum",
        desc: "Verkaufsraum in Szene setzen und Ihrem Kunden einen angenehmen Aufenthalt bieten.",
      },
      hunter: {
        title: "Hunter",
        desc: "Punkte gegen attraktive Werkstatt-Ausrüstung von Hunter eintauschen.",
      },
    },
    bestSold: "Meistgekauft",
    seasonal: "Saisonales",
    affordable: "Fast geschafft",
    forPoints: "für {points} Punkte",
    reachedPoints: "Benötigten Punktestand erreicht",
    cartRemainPoints: "Punkte verbleibend",
    remainingPoints: "{points} Punkte noch fehlend",
  },
  externeTraining: {
    title: "Externe Schulungen",
    description:
      "Sichern sie sich Expertenwissen und bei erfolgreicher Teilnahme an den jeweiligen Tests zum Training Ihr persönliches Teilnahme-Zertifikat sowie einmalig 40 Extrapunkte für den Prämienclub",
    additionalInfo:
      "Neben unseren kostenfreien Online-Trainings und den kostenpflichtigen Bridgestone Schulungen bieten wir Ihnen auch die Möglichkeit, externe Schulungen mit Ihren Prämienpunkten – je nach Ihrem Guthaben - zu finanzieren bzw. zu bezuschussen.",
    itsEasy: "So einfach geht es:",
    excludeText:
      "Bitte haben Sie Verständnis, dass Angebote des direkten Wettbewerbs ausgeschlossen sind.",
    downloadSection: {
      title: "Download Rechnungsvorlage",
      description1:
        "Laden Sie hier eine Vorlage für Ihre Punkteabrechnung an uns herunter.",
      description2: "Auf dem Beispiel finden Sie alle Angaben, die nötig sind.",
    },
    form: {
      title: "Antrag",
      thirdPartyInvoice: "Rechnung Drittanbieter",
      userInvoice: "Meine Rechnung",
      bankAccountOwner: "Kontoinhaber",
      uploadInvoice: "Meine Rechnung über die eingesetzten Punkte hochladen",
      have: "Ich möchte",
      thirdPartyInvoiceDesc:
        "Punkte in einem %{calculatePriceDiscount} EUR von für folgende",
      userInvoiceDesc:
        "Schulungsrechnung einsetzen, Rechnung Drittanbieter hochladen",
    },
    info: {
      paragraph1:
        " Sie nehmen selbst oder Ihre Team an einer fachlichen Schulung eines Drittanbieters teil.",
      paragraph2: "Sie gleichen die Rechnung des Drittanbieter aus.",
      paragraph3:
        "Sie stellen hier auf dieser Seite im Anfragefeld den Antrag auf Bezuschussung",
      elements: {
        first: "Rechnung des Drittanbieters hochladen",
        second:
          "Höhe der Punkte eintragen, die Sie einsetzen möchten (maximal in Höhe des Netto-Rechnungsbetrages)",
        third:
          "Sie erstellen eine Rechnung Ihres Betriebs in Höhe der eingesetzten Punkte (0,25 EUR netto pro Punkt) und laben diese ebenfalls hoch",
        fourth: "Die Rechnungen und der Antrag werden geprüft",
        fifth: "Sie erhalten eine Auszahlung in Höhe der eingesetzten Punkte",
      },
    },
    success: {
      title: "Vielen Dank",
      paragraph: {
        first: "Ihr Antrag ist eingegangen.",
        second:
          "Sie erhalten nach positiver Prüfung die Erstattung in Höhe der eingesetzten Punkte auf das angegeben Konto gutschrieben.",
        third:
          "Prüfung und Auszahlung können bis zu 6 Wochen in Anspruch nehmen.",
        fourth:
          "Ihr Punktekonto haben wir um die Höhe der eingesetzten Punkte reduziert.",
        fifth: "Eine Kopie des Antrags finden Sie in Ihrem",
      },
    },
  },
  buttons: {
    toSearch: "Suchen",
    sendRequest: "Anfrage senden",
    formButton: "zum formular",
    discoverButton: "entdecken",
    sendButton: "Abschicken",
    makeContact: "Kontakt aufnehmen",
    userProfile: "Zu ihren stammdaten",
    userOrders: "Zu ihren bestellungen",
    mailbox: "Zum postfach",
    pointsList: "Zum kontoauszug",
    next: "Weiter",
    back: "ZURÜCK",
    skip: "Überspringen",
    toTheBasket: "In den Warenkorb",
    edit: "Bearbeiten",
    cancel: "Abbrechen",
    select: "Auswählen",
    newOrder: "Neue Bestellung",
    downloadAll: "Alle downloaden",
    readNow: "Jetzt lesen",
    toDashboard: "Zur Startseite",
    moreCustomerNumbers: "+ WEITERE KDNR. ANGEBEN",
    toProductInfo: "PRODUKTINFORMATIONEN ENTDECKEN",
    toAccount: "ZUM PUNKTEKONTO",
    toSalesPromotions: "JETZT IHREN BETRIEB ANMELDEN",
    show: "JETZT ENTDECKEN",
    toOnlineTrainings: "ZU DEN ONLINE-TRAININGS",
    newAddress: "Neue lieferadresse erstellen",
    toQuiz: "Zum Quiz",
    toDownload: "Zum download",
    calculate: "Berechnen",
    reset: "Neue Berechnung",
    register: "Anmelden",
    refuseBtn: "ABLEHNEN",
    acceptBtn: "AKZEPTIEREN",
    toCommitmentLetter: "ZUM VERPFLICHTUNGSBRIEF",
    toKickbackFeeInfo: "ZUR ERLÄUTERUNG DER GEBÜHR & PUNKTE",
    clickHere: "Details ansehen",
    directBuy: "Direkt bestellen",
    toDiscover: "Entdecken",
    dealerInfoDownload: "HÄNDLERINFORMATION HERUNTERLADEN",
    all: "Alle",
    clearFilters: "Filter zurücksetzen",
    selectAll: "Alles auswählen",
    deselectAll: "Auswahl aufheben",
    downloadSelection: "Auswahl herunterladen",
    preview: "Vorschau",
    vouchers: "Zur Punkteübersicht",
    exchangeVoucher: "Gutscheincode einlösen",
    confirm: "BESTÄTIGEN",
    toFavorites: "Zu Ihren Lieblingsprodukten",
  },
  myAccount: "Ihre Konto",
  menu: {
    // TODO - clear unused menu items
    account: "Mein Konto",
    plus: 'Über Bridgestone <span class="text-danger">Plus</span>',
    salesSupport: "Verkaufsunterstützung",
    mailbox: "Postfach",
    about: "Über BS Plus",
    trainingAndCourses: "Trainings & Schulungen",
    externalTraining: "Externe Schulungen",
    productInfo: "Produktinformationen",
    productBrochures: "Produktbroschüren",
    priceLists: "Preislisten",
    price: "Pricat",
    complaintForm: "Beanstandungsformular",
    sales_support: "Verkaufsunterstützung",
    contact_service: "Kontakt & Service",
    logOut: "Ausloggen",
    news: "Aktuelles",
  },
  productInfo: {
    categories: {
      info: "Produkt-infos",
      priceList: "Preislisten",
      contact: "Kontakt",
    },
    page: {
      description:
        "Willkommen im Informationsbereich Rund um die Produkte von Bridgestone & Fisrestone.Hier finden Sie aktuelle Broschüren und Preislisten sowie hilfreiche Links und Formulare.",
    },
    index: {
      title: "Produktinformationen",
      description:
        "Willkommen im Informationsbereich rund um die Produkte von Bridgestone und Firestone.Hier finden Sie aktuelle Broschüren und weiterführende Materialien.",
      categories: {
        productBrochures: {
          title: "Produktbroschüren & Preislisten",
          description:
            "Aktuelle Bridgestone und Firestone Produkt-broschüren und Preislisten zum Download",
        },
        bDrive: {
          title: "Produkt-Abbildungen",
          description:
            "Aktuelle Abbildungen finden Sie in unserem B-DRIVE Portal zum Download",
          button: "ZU B-DRIVE",
        },
        calculator: {
          title: "Spritspar<span class='text-danger'>-Rechner</span>",
          description:
            "Reifen mit optimiertem Rollwiderstand –Einsparpotentiale einfach berechnen!",
        },
        carApprovals: {
          title: "Pkw Freigaben Bridgestone",
          description:
            "Finden Sie die passenden Bridgestone Pkw-Reifen mit Zulassung",
        },
        carApprovalsFS: {
          title: "Pkw Freigaben Firestone",
          description:
            "Finden Sie die passenden Firestone Pkw-Reifen mit Zulassung",
        },
        motApprovals: {
          title: "Motorrad Freigaben",
          description:
            "Finden Sie die passenden Bridgestone Motorradreifen mit Zulassung",
        },
        dataGenereate: {
          title: "Datenblatt-Generator",
          description:
            "Tippe Sie die IPC ein und generieren Ihr eigenes Datenblatt",
        },
      },
    },
  },
  productList: {
    pkw: {
      title: "Preislisten Pkw-, 4x4- und Transporter-Reifen",
      description:
        "Laden Sie hier aktuelle Preislisten zu unseren Bridgestone und Firestone Reifen herunter: <ul> <li>Pkw, 4x4 und Transporter</li> </ul>",
    },
    trucksAndBuses: {
      title: "Preislisten Lkw und Busse",
      description:
        "Laden Sie hier aktuelle Preislisten zu unseren Bridgestone und Firestone Reifen herunter: <ul> <li>Lkw und Busse</li> </ul>",
    },
    motorcycles: {
      title: "Preislisten Motorrad-Reifen",
      description:
        "Laden Sie hier aktuelle Preislisten zu unseren Bridgestone Reifen herunter: <ul> <li>Motorrad</li> </ul>",
    },
    agriculture: {
      title: "Preislisten Landwirtschafts-Reifen",
      description:
        "Laden Sie hier aktuelle Preislisten zu unseren Bridgestone und Firestone Reifen herunter: <ul> <li>Landwirtschaft</li> </ul>",
    },
    constructionMachineryOtr: {
      title: "Preislisten Baumaschinen-/OTR-Reifen",
      description:
        "Laden Sie hier aktuelle Preislisten zu unseren Bridgestone und Firestone Reifen herunte: <ul><li>Baumaschinen/OTR</li></ul>",
    },
    main: {
      title: "Preislisten",
      description:
        "Laden Sie hier aktuelle Preislisten zu unseren Bridgestone und Firestone Reifen herunter: <ul><li>Pkw, 4x4 und Transporter</li><li>Motorrad</li><li>Lkw und Busse</li> <li>Landwirtschaft</li><li>Baumaschinen / OTR</li></ul>",
    },
    index: {
      description:
        "Willkommen im Informationsbereich rund um die Produkte von Bridgestone und Firestone. Hier finden Sie aktuelle Broschüren, Preislisten, Pricat Dateien, Freigabemanagement-Tools und unseren Datenblatt-Generator.",
    },
  },
  productBrochures: {
    desc: "Laden Sie hier aktuelle Broschüren und Flyer zu unseren Bridgestone und Firestone Reifen für Pkw, SUV und Transporter herunter.",
    technologiesTitle: "Technologien, Markierungen und mehr",
    technologiesDesc:
      "Laden Sie hier aktuelle Broschüren und Flyer zu unseren Technologien, Markierungen und mehr für Pkw, SUV und Transporter herunter.",
    BDriveTitle: "Produktabbildungen",
    BDriveDesc:
      "Hier finden Sie Profilabbildungen, Logos und mehr für alle Produktbereiche und Marken zum Download.",
    BDriveLinkText: "Link zum REIFENABBILDUNGEN & LOGOS Portal",
  },
  contact: {
    index: {
      title: "Kontakt & Service",
      description:
        "Herzlich willkommen im Servicebereich von BRIDGESTONE PLUS. Hier finden Sie die Kontaktdaten unseres Serviceteams, sowie Ihre Ansprechpartner nach Region.",
    },
    categories: {
      service: {
        description: "Servicenummer für Ihre Region sowie E-Mail-Kontakt",
      },
      form: {
        description:
          "Produktbeanstandungen direkt hier über das Formular einreichen",
      },
      touch: {
        title: "Contact Touch Incentive",
        description:
          "Wenn Sie Fragen zu den Produkten im Bridgestone Plus-Geschenkshop, zu getätigten Bestellungen, Lieferzeiten und/oder Lieferungen haben, wenden Sie sich bitte an den externen Geschenkshop-Lieferanten: Touch Incentive Rotterdam: 010 2043075 oder support&#64;touchincentive.com.",
      },
    },
    form: {
      intermediaryAddress: "Anschrift zwischenhändler",
      nameFirma: "Name / Firma",
      strHouseNr: "Straße & Hausnr.",
      contactPerson: "Ansprechpartner/in",
      vehicleDetails: "Angaben zum Fahrzeug",
      vehicleTyres: "Fahrzeug/Reifen*",
      brandNew: "Neuware (nicht montiert)",
      newItem: "Neuware (montiert)",
      fwd: "Frontantrieb",
      rwd: "Heckantrieb",
      awd: "Allrad",
      vehicleManufacturer: "Fahrzeughersteller",
      vehicleModelType: "Fahrzeugmodell und Typbezeichnung lt. Zulassung",
      firstRegistration: "Erstzulassung (TT.MM.JJJJ)",
      enginePower: "Motorleistung (KW z.B. 150)",
      originalEquipment: "Erstausrüstung",
      tireMilageHours: "Laufleistung Reifen (km) / Betriebsstunden",
      tireMilage: "Laufleistung Reifen (km)",
      tireHours: "Betriebsstunden",
      milageOrHours: "Km oder Stunden (z.B. 2000)",
      copyTire1: "Reifen 1 kopieren",
      copyTire3: "Reifen 3 kopieren",
      damageDetails: "Schadendetails",
      complaintReason: "Beanstandungsgrund*",
      vibration: "Vibration",
      notBalancable: "Nicht auswuchtbar",
      sounds: "Geräusche",
      airPressureLost: "Luftdruckverlust",
      worn: "Abriebsbild",
      runningPerformance: "Laufleistung",
      deformation: "Beulen / Verformungen",
      profileBreakouts: "Profilausbrüche",
      cracks: "Risse",
      drivingBehavior: "Fahrverhalten",
      pull: "Ziehen",
      wetGrip: "Nasshaftung",
      defective:
        'Defekte Neuware (bitte Lieferschein Nr. unter "Beanstandungsgrund Text" angeben)',
      otherReason:
        "Anderer Grund (bitte unter „Beanstandungsgrund Text“ angeben)",
      isTyreReplaced: "Wurden die Reifen bereits ersetzt?*",
      ifYesTyre: "Falls ja, Marke der Ersatzreifen",
      clerkName: "Name des Sachbearbeiters*",
      conclusion: "Abschluss",
      conclusionContent:
        "<p>Diese Angaben sind vollständig und wurden nach bestem Wissen gemacht.Es wird versichert, dass die beanstandete Bereifung auf vorgenanntemFahrzeug gefahren wurde. <br /><br /><b>Die Bereifung kann zu Prüfzwecken geschnitten werden. </b><br /><br /><b>Bei Anerkennung der Beanstandung behalten wir uns vor, dieBereifung nach wertanteiliger Gutschrift zu erstatten, oder durcheine kostenlose Ersatzlieferung zu kompensieren.</b><br />Die anerkannte Bereifung wird verschrottet. Bei Ablehnung kann diesezurück gefordert werden. <br /><br />Die Speicherung o.g. personenbezogener Daten wird gestattet.</p>",
      agreementReadAccept: "Vereinbarung gelesen und akzeptiert.*",
      termsConditionsRead: "Allgemeine Geschäftsbedingungen lesen.",
      termsConditionsReadAccept: "AGB gelesen und akzeptiert.*",
      send: "Abschicken",
      requiredField: "*Pflichtfeld",
      tires: "Reifen",
      tirePosition: "Reifenposition",
      notKnown: "Nicht bekannt",
      carSUVTractor: "PKW/SUV/TRAKTOR",
      CSTFrontLeft: "P/S/T-vorne links",
      CSTFrontRight: "P/S/T-vorne rechts",
      CSTRearLeft: "P/S/T-hinten links",
      CSTRearRight: "P/S/T-hinten rechts",
      motorcycle: "MOTORRAD",
      motFront: "MOT-vorne",
      motRear: "MOT-hinten",
      truck: "LKW SZM",
      truckSteeringAxle1Left: "LKW-Lenkachse 1 links",
      truckSteeringAxle1Right: "LKW-Lenkachse 1 rechts",
      truckSteeringAxle2Left: "LKW-Lenkachse 2 links",
      truckSteeringAxle2Right: "LKW-Lenkachse 2 rechts",
      truckDriveAxle1LeftInner: "LKW-Antriebsachse 1 links innen",
      truckDriveAxle1LeftOuter: "LKW-Antriebsachse 1 links außen",
      truckDriveAxle1RightInner: "LKW-Antriebsachse 1 rechts innen",
      truckDriveAxle1RightOuter: "LKW-Antriebsachse 1 rechts außen",
      truckDriveAxle2LeftInner: "LKW-Antriebsachse 2 links außen",
      truckDriveAxle2LeftOuter: "LKW-Antriebsachse 2 links innen",
      truckDriveAxle2RightInner: "LKW-Antriebsachse 2 rechts außen",
      truckDriveAxle2RightOuter: "LKW-Antriebsachse 2 rechts innen",
      truckTrailingAxleLeft: "LKW-Nachlaufachse links",
      truckTrailingAxleRight: "LKW-Nachlaufachse rechts",
      trailerSemi: "ANHÄNGER/AUFLIEGER",
      trailerAxle1LeftOuter: "TRAILER-Achse 1 links außen",
      trailerAxle1LeftInner: "TRAILER-Achse 1 links innen",
      trailerAxle1RightOuter: "TRAILER-Achse 1 rechts außen",
      trailerAxle1RightInner: "TRAILER-Achse 1 rechts innen",
      trailerAxle2LeftOuter: "TRAILER-Achse 2 links außen",
      trailerAxle2LeftInner: "TRAILER-Achse 2 links innen",
      trailerAxle2RightOuter: "TRAILER-Achse 2 rechts außen",
      trailerAxle2RightInner: "TRAILER-Achse 2 rechts innen",
      trailerAxle3LeftOuter: "TRAILER-Achse 3 links außen",
      trailerAxle3LeftInner: "TRAILER-Achse 3 links innen",
      trailerAxle3RightOuter: "TRAILER-Achse 3 rechts außen",
      trailerAxle3RightInner: "TRAILER-Achse 3 rechts innen",
      DOT: "DOT (bitte ALLE 10-11 Stellen angeben)",
      TruckSerialNo: "Serien-Nr. (nur bei LKW Reifen)",
      complaintReasonText: "Beanstandungsgrund Text",
      csNumberIfNeed: "Kundennummer (falls vorhanden)",
    },
    teams: {
      tyre: "Team Reifenhandel",
      car: "Team Autohaus",
    },
    carDealers: {
      title: "Ihre persönlichen Ansprechpartner bei Bridgestone",
    },
  },
  mainPage: {
    categories: {
      productInfo: "Produkt-informationen",
      salesSupport: "Verkaufs-unterstützung",
    },
  },
  fireStoneProducts: {
    title: "Produkte Firestone",
    description:
      "Zwei flinke Boxer jagen die quirlige Eva und ihren Mops durch Sylt. Franz jagt im komplett verwahrlosten Taxi quer durch Bayern. Zwölf Boxkämpfer jagen Viktor quer über den großen Sylter Deich. Vogel Quax zwickt Johnys Pferd Bim.",
    files: {
      summer: {
        title: "VANHAWK MULTISEASON",
        description: "Transporter - All Season",
        date: "Produktübersicht 2021",
      },
      winter: {
        title: "WINTERHAWK 4",
        description: "Pkw, SUV - Winter",
        date: "Produktübersicht 2020",
      },
    },
  },
  complaintForm: {
    title: "Beanstandungsformular",
    description:
      "Füllen Sie das nachfolgende Formular für Beanstandungen zu unseren Reifen  aus:",
    sections: {
      damageType: {
        title: "schadenstyp",
      },
      generally: {
        title: "allgemein",
      },
      regulator: {
        title: "Anschrift reifenhändler - regulierer",
      },
    },
    fields: {
      ordinance: "Ordnungsbegriff des Händlers",
      pickupLocation: "Abholort",
      ifAvailable: "(falls vorhanden)",
      companyName: "Name (Firma)",
    },
  },
  salesPromotions: {
    title: "Verkaufsförderung",
    desc: "Mit unseren Verkaufsförderungsaktionen für Bridgestone und Firestone unterstützen wir Sie aktiv im Verkaufsgespräch und geben Ihnen zusätzliche Argumente an die Hand. Wenn Sie Aktionen auch für Ihr Geschäft nutzen wollen, können Sie sich auf dieser Seite informieren und auch gleich Ihre Teilnahme als Handelspartner beantragen",
    bonusCampaign: {
      title:
        '<span class="font-sm">Bridgestone Prämienaktion</span><h3 class="fw-bold">DRIVE <span class="text-danger">OUR BEST</span></h3>',
      desc: "Im Rahmen der Aktion DRIVE OUR BEST erhalten Kunden mit dem Kauf von mindestens 2 Bridgestone Premiumreifen im teilnehmenden Handel einen Wertgutschein von bis zu 40 EUR, einzulösen bei attraktiven Partnern wie Amazon, Aral/OMV, Media Markt, REWE, Shell, Zalando uvm. Die Höhe des Wertgutscheins ist abhängig von der Anzahl der erworbenen Reifen sowie deren Zollgröße.",
    },
    guarantee: {
      title:
        '<span class="font-sm">Bridgestone Reifengarantie</span><h3 class="fw-bold">TYRE <span class="text-danger">PROTECT</span></h3>',
      desc: "Einfahrschäden und Schäden durch Bordsteine - was bislang mit Frust und Ärgernis verbunden war, löst Bridgestone seit 2020 erfolgreich digital, händler- und kundenfreundlich mit einer zweijährigen Reifengarantie.Je nach Alter seines abgesicherten Bridgestone Reifen erhält Ihr Kunde im Schadensfall bis zu 100% des Kaufpreises für den Ersatzreifen zurück.Neu seit 2023: Ihre Kunden können die Garantie schon beim Kauf ab 2 Reifen aller Zollgrößen in Anspruch nehmen. ",
    },
    premium: {
      title:
        '<span class="font-sm">Firestone Prämie & Garantie</span><h3 class="fw-bold">VORTEILS<span class="text-danger">AKTION</span></h3>',
      desc: "Bei Teilnahme an der FIRESTONE VORTEILSAKTION erhalten Käufer von mindestens 2 Firestone Reifen nicht nur eine 24-monatige Reifengarantie, die z.B. Bordstein- oder Einfahrschäden absichert, sondern auch einen Wunschgutschein von BestChoice im Wert von bis zu 20 EUR.Neu seit 2023: Die Teilnahme ist bereits beim Kauf ab 2 Pkw-, SUV-, oder Transporterreifen aller Zollgrößen möglich.",
    },
    participation: {
      title: "Jetzt Teilnahme beantragen",
      desc: "Sie möchten eine oder mehrere unserer Aktionen in Ihrem Geschäft umsetzen? Dann können Sie hier Ihre Teilnahme beantragen. Ihr Betrieb wird für die Aktion(en) freigeschaltet und Sie erhalten innerhalb von 4 Wochen Aktionsmaterial für Ihren Verkaufsraum. Treffen Sie Ihre Auswahl:",
      success: "Viele Dank, Ihre Anfrage wurde gesendet",
      bonusCampaign:
        '<span class="fw-bold">DRIVE <span class="text-danger">OUR BEST</span> - Die Bridgestone Prämienaktion',
      guarantee:
        '<span class="fw-bold">TYRE <span class="text-danger">PROTECT</span></span> - Bridgestone Reifengarantie',
      advantage:
        '<span class="fw-bold">VORTEILS<span class="text-danger">AKTION</span></span> - Die Firestone Prämieaktion mit zusätzlicher Reifengarantie',
      premium:
        '<span class="fw-bold">VORTEILS<span class="text-danger">AKTION</span></span> - Die Firestone Prämieaktion mit zusätzlicher Reifengarantie',
      request: "Teilnahme beantragen",
    },
  },
  trainings: {
    seasons: {
      all: "All Season",
      summer: "Sommer",
      winter: "Winter",
      general: "General",
    },
    offer:
      "Wir erweitern regelmäßig unser <br />Angebot für Sie! <br /><br />Über neue Trainings informieren <br />wir Sie in Ihrem Postfach.",
    summary: {
      congratulations:
        "HERZLICHEN GLÜCKWUNSCH - SIE HABEN IHR EXPERTENWISSEN ZU",
      participation: "Sie haben erfolgreich am {name} teilgenommen.",
      certificate:
        "Ihr Zertifikat erhalten Sie per E-Mail oder können es auch hier direkt als PDF herunterladen:",
      send: "Zertifikat herunterladen",
    },
    online: {
      title: "Unsere Online-Trainings",
      desc: "Sichern sie sich Expertenwissen und bei erfolgreicher Teilnahme an den jeweiligen Tests zum Training Ihr<br> persönliches Teilnahme-Zertifikat sowie einmalig 40 Extrapunkte für den Prämienclub",
      short_desc:
        "Sichern sie sich Expertenwissen und bei erfolgreicher Teilnahme an den jeweiligen Tests zum Training Ihr<br> persönliches Teilnahme-Zertifikat sowie einmalig 40 Extrapunkte für den Prämienclub",
      content:
        "Jetzt unsere aktuellen Online-Trainings entdecken und sofort hier auf der Plattform teilnehmen:",
      categories: {
        title: "Online-Trainings",
        description:
          "Sichern Sie sich Expertenwissen und bei erfolgreicher Teilnahme an den jeweiligen Tests zum Training Ihr persönliches Teilnahme-Zertifikat sowie einmalig 40 Extrapunkte für den Prämienclub.",
        general: {
          title: "Allgemein",
          subtitle: "Online-Trainings: Allgemein",
          description:
            "Entdecken Sie die neusten Technologien, wichtige Entwicklungen in der Reifenbranche, Tipps für Ihr Verkaufsgespräch und mehr.",
          subdesription:
            "Sichern sie sich Expertenwissen und bei erfolgreicher Teilnahme an den jeweiligen Tests zum Training Ihr persönliches Teilnahme-Zertifikat sowie einmalig 40 Extrapunkte für den Prämienclub",
        },
        product: {
          title: "Produkte",
          subtitle: "Online-Trainings: Produkte",
          description:
            "Vertiefen Sie mit unseren kompakten Trainingsvideos Ihre Bridgestone und Firestone Produktexpertise für den erfolgreichen Abverkauf.",
          subdesription:
            "Sichern sie sich Expertenwissen und bei erfolgreicher Teilnahme an den jeweiligen Tests zum Training Ihr persönliches Teilnahme-Zertifikat sowie einmalig 40 Extrapunkte für den Prämienclub",
        },
      },
    },
    lectures: {
      title: "Bridgestone Schulungen",
      desc: "Bauen Sie Ihr Expertenwissen weiter aus und buchen Sie unsere Schulungen und Intensiv-Trainings für sich und Ihr Team. Sie haben dabei die Möglichkeit, an den Schulungen im Bridgestone Kompetenz- und Training-Center in Dietzenbach (bei Frankfurt am Main) teilzunehmen oder bei ausgewählten Schulungen diese auch bei Ihnen im Betrieb durchführen zu lassen. Sie können für die Schulungen Ihre Prämienpunkte einsetzen und damit so die Kosten ganz oder teilweise mit Ihren Punkten verrechnen.",
      content:
        "Jetzt unsere aktuellen Schulungen entdecken und Buchung anfragen:",
    },
    singleLecture: {
      registerForm: {
        title: "Inhalte der Schulung",
        inquiry: "Anfrage",
        interested: "Ich interessiere mich für die Schulung",
        participantsNr: "Teilnehmerzahl",
        pointsFromBalance:
          "Ich möchte Punkte von meinem Punkteguthaben einsetzen.",
        reduction: "Dies entspricht einer Kostenreduzierung von {points} Euro.",
        request: "Anfrage senden",
      },
      success: {
        thanks: "Vielen Dank",
        title: "Ihre Anfrage wurde an das Schulungsteam gesendet.",
        feedbackTime:
          "Sie erhalten innerhalb von 14 Tagen eine Rückmeldung zur Klärung aller<br />Details.",
        points:
          "Die eingesetzten Prämienpunkte i.H.v.<br /><strong>{points}</strong> Punkten wurden Ihrem<br />Punktekonto abgezogen.",
        refund:
          "Sollte die Schulung nicht zustande kommen, werden Ihnen die Punkte<br />selbstverständlich wieder gutgeschrieben.",
        queries: "Für Rückfragen wenden Sie sich bitte an:",
      },
      index: {
        costs: "Kosten und Teilnahmeinformationen",
        duration: "Dauer: {duration}",
        cost: "Kosten {cost}: {price} Euro ({points} punkten)",
        participantsNr: "Teilnehmerzahl: mind. {min} -max. {max} Personen",
      },
    },
    index: {
      title: "Trainings & Schulungen",
      desc: "Vorsprung durch Wissen: Sichern Sie sich mit unseren Trainingsangeboten exklusives Fachwissen für Sie und Ihr Team. Ob mit unseren Online-Trainings, an denen Sie direkt ihr auf der Plattform  teilnehmen können, mit unseren Schulungen und Praxisseminaren im Bridgestone Trainingscenter oder auch mit externen Trainings, deren Kosten Sie mit Ihren Prämienpunkten reduzieren können.",
      online: {
        title: "Online-Trainings",
        desc: "Online-Trainings entdecken und Einblicke in die Produktwelt von Bridgestone gewinnen!",
        short_desc:
          "Online-Trainings entdecken und Einblicke in die Produktwelt von Bridgestone gewinnen!",
      },
      lectures: {
        title: "Schulungen",
        desc: "Hochwertige Schulungsangebote in unserem Trainingscenter oder bei sich vor Ort.",
      },
      external: {
        title: "Externe Schulungen",
        desc: "Prämienpunkte für Angebote von Drittanbieter nutzen und Kosten senken.",
      },
    },
  },
  salesSupport: {
    title: "Verkaufsunterstützung",
    desc: "Wir bieten Ihnen verschiedene Maßnahmen und Aktionen an, um Ihren Verkauf aktiv zu unterstützen - von der impulsstarken Verkaufsförderungsaktion über einen attraktiven Verkaufsraum bis hin zur individuellen Unterstützung.",
    salesPromotions: {
      title: "Verkaufsförderung",
      desc: "Attraktive Zugaben und Garantien für Ihre Kunden beim Reifenkauf.",
    },
    displaysFurniture: {
      title: "Displays & Möbel",
      desc: "Mit Ihren Prämienpunkten zu hochwertigen Ausstattungen für Ihren Verkaufsraum.",
    },
    individualSupport: {
      title: "Individueller Support",
      desc: "Mit Ihren Prämienpunkten individuelle Unterstützung sichern.",
    },
  },
  serviceNumber: {
    title: "Ansprechpartner und service-nummern",
    subtitle: "Ihre persönlichen Ansprechpartner bei Bridgestone ",
    description:
      "Wir sind immer für Sie da! Finden Sie hier Ihre persönlichen Bridgestone Ansprechpartnerfür Ihre Region oder wenden Sie sich einfach an unseren kompetenten Mitarbeiterinnen undMitarbeiter aus dem Kundenservice.",
    manager: "Sales Manager Deutschland",
    yourCustomerService: "Ihr Kundenservice",
    generalCustomerService: "Kundenservice allgemein",
    salesTerritory: "Verkaufsgebiet",
    carDealer: "Autohaus",
    centralEmail: "Zentraler E-mail-Kontakt",
    sales_manager: "Sales manager Nederland",
    contact_person: "Bridgestone plus contactpersoon",
    sales_representative: "Sales representative",
    key_account: "Key Accountmanager",
    warranty: "Gewährleistung",
    car_releases: "Pkw-Freigaben",
    motorcycle_releases: "Motorrad-Freigaben",
    commercial_vt: "Nutzfahrzeug-Reifen",
    agricultural_tires: "Landwirtschafts-Reifen",
  },
  directions: {
    west: "West",
    north: "Nord",
    east: "Ost",
    south: "Süd",
  },
  training: {
    title: "Zertifikat und {points} Extrapunkte für Sie!",
    subtitle:
      " Sichern Sie sich Ihr persönliches Teilnahmezertifikat und zusätzlich {points} Extrapunkte für den Prämienclub.",
    description:
      "Und wie? Ganz einfach: Schließen Sie den Test zum Training nach dem Video erfolgreich ab! Der Test erscheint, sobald Sie das Video vollständig angeschaut haben!",
  },
  about: {
    title: "Über Bridgestone <span class='text-danger'>Plus</span>",
    description:
      "IHR <span class='text-danger'>PLUS</span> MIT BRIDGESTONE - dies ist unser Leitmotiv des gesamten BRIDGESTONE <span class='text-danger'>PLUS</span>Programms für unsere Handelspartner. Entdecken Sie die zahlreichen exslusiven Vorteile.",
    sections: {
      first: {
        title: "Ausgezeichnete Produkte im Premium- und Quality-Segment",
      },
      second: {
        title: "Attraktives Prämienprogramm",
      },
      third: {
        title: "Wirksame Verkaufsunterstützung",
        description:
          "Erweiterte Möglichkeiten für exklusive Einkaufserlebnisse und Ihre digitale Präsenz an relevanten Touchpoints.",
        subtitle: "Unsere bewährten Verkaufsförderungsaktionen",
        pointInfo:
          "Profitieren Sie von zusätzlichen Verkaufsargumenten und Ihre Kunden von spannenden Prämien- und Mehrwertaktionen.",
        numberInfo:
          "Digitale Direktabwicklung mit Ihrem Kunden – kein Mehraufwand für Sie!",
        subtitle2: "Starker Auftritt mit unserer Verkaufsraumausstattung",
        description2:
          "Setzen Sie Ihren Verkaufsraum attraktiv in Szene und bieten Sie Ihren Kunden einen angenehmen Aufenthalt mit unseren Modulen für Thekenbereiche, Ausstellungsflächen, Warte- und Außenbereiche sowie Digitale Lösungen!",
        description3:
          "Sammeln Sie Punkte und <b>fördern Sie Ihr Unternehmen</b> mit uns",
      },
      fourth: {
        title: "ALLES AUF EINER PLATTFORM: DAS BRIDGESTONE PLUS PORTAL",
        description:
          "Mit Ihrem persönlichen Zugang zum Online-Portal haben Sie direkten Zugriff auf das<br>vielfältige Angebot von BRIDGESTONE <span class='text-danger'>PLUS</span>.",
        list: {
          program: "Punkteprogramm",
          shop: "Prämienshop",
          priceList: "Preislisten",
          productInfo: "Produktinformationen",
          salePromotion: "Verkaufsunterstützung",
          onlineTrainings: "Online-Trainings",
          andMore: "und vieles mehr.",
        },
        title2: "Regelmässige Online-trainings",
        description2:
          "Bleiben Sie immer auf dem neusten Stand und profitieren Sie gemeinsam mit Ihrem Team von Bridgestone Online-Trainings ",
      },
      points: {
        title:
          "Aktuelle Online-Trainings aus den Bereichen Produkte und Verkaufen:",
        list: {
          one: "Verkaufstraining",
          two: "Reifenkonstruktionen",
          three: "Schadenbilder erkennen",
        },
        subtitle: "IHRE TEilnahme wird belohnt",
        description:
          "Sie erhalten <b>40 Punkte</b> sowie ein <b>Teilnahme-zertifikat</b> für jedes abgeschlossene Online-Training!",
      },
    },
    fullPremium:
      "Das gesamte Bridgestone Pkw Premium-Sortiment für den Ersatzmarkt wurde im <strong>Bereich Nasshaftung durchgehend mit „A“ bewertet.</strong>",
  },
  her: "Ihre",
  seasons: {
    summer: "Sommer",
    winter: "Winter",
    all: "All Seasons",
  },
  loginPage: {
    title: "Anmelden",
    resetTitle:
      'Willkommen bei BRIDGESTONE <span class="text-danger">PLUS</span>',
    desc1:
      'Sie haben sich bereits erfolgreich auf dem Portal BRIDGESTONE <span class="text-danger">PLUS</span> angemeldet.',
    desc2:
      "Dann loggen Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort ein.",
    desc3: "Loggen Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort ein.",
    resetSubTitle:
      'Sie sind Bridgestone TYRE<span class="text-danger">CLUB</span> Teilnehmer?',
    resetDesc:
      "Dann setzen Sie zunächst über die Funktion <b>Passwort vergessen</b> Ihr neues Passwort für die E-Mail-Adresse, die Sie für den TYRE<span class='text-danger'>CLUB</span> verwendet haben.",
    footer: "Danach werden Sie automatisch eingeloggt.",
    resetNewPass: "NEUES PASSWORT SETZEN",
    noAccount: "Ich habe noch kein Konto",
    error: "Falsche Anmeldedaten, bitte versuchen Sie es erneut!",
    logWithAzure: "Melden Sie sich mit Azure an",
  },
  maintenance: {
    title: "Wartungsarbeiten!",
    desc: 'Aktuell finden notwendige Wartungsarbeiten an den Servern statt.Daher steht Ihnen aktuell der Zugang zu <b>BRIDGESTONE <span class="text-danger">PLUS</span></b> nicht zur Verfügung.Wir bitten um Ihre Geduld und bedanken uns für Ihr Verständnis. Ihr Bridgestone Team',
  },
  contactPage: {
    title: "Beanstandungs-Formular",
    description:
      "Füllen Sie das nachfolgende Formular für Beanstandungen zu unseren Reifen  aus:",
    damage: "Sachschaden",
    personalInjury: "Personenschäden",
  },
  yesText: "ja",
  noText: "nein",
  wrongFileError: "Das erforderliche Dateiformat ist PDF",
  toastMessages: {
    addProduct: "Ihr Produkt wurden zum Warenkorb hinzugefügt.",
    addProducts: "Ihre Produkte wurden zum Warenkorb hinzugefügt.",
    profileSaved: "Die Daten Ihres Profils wurden gespeichert",
    canAddProduct: "Du hast nicht genug Punkte.",
    customerNumberSaved: "Kundennummer gespeichert",
    customerNumberExist: "Kundennummer vorhanden",
    complaintForm:
      "Ihre Anfrage wurde angenommen. Bitte warten Sie auf eine Antwort",
    openHourSaved: "Öffnungszeiten wurden gespeichert",
    changeParentId:
      "Sie können die Zweigstelle mit der übergeordneten Kundennummer nicht ändern, wenn sie untergeordnete Zweige hat",
    requestSent: "Anfrage wurde gesendet",
    completeProfileRequired:
      "Sie sollten Ihr Profil mit 100 % ausfüllen, um mit dem Kauf im Shop fortzufahren.",
    accessDenied: "Zugriff abgelehnt",
    incomplete_address: "Adresse ist unvollständig. überprüfen Sie bitte",
    waitMoment: "Moment mal",
    favoriteAdded: "Zu Favoriten hinzugefügt.",
    favoriteRemoved: "Aus Favoriten entfernt.",
    downloadFinished: "Download beendet",
    selectOneField: "Wählen Sie ein Feld aus",
    noVoucher: "Gutschein wurde nicht gefunden",
  },
  order: {
    number: "Bestellnr.",
    createdDate: "Bestellt am",
    description:
      "Hier finden Sie eine Übersicht Ihrer Prämienshop-Bestellungen.",
    success:
      "Vielen Dank! Ihre Bestellung war erfolgreich. Sie erhalten in wenigen Minuten eine Bestellbestätigung in Ihr Postfach.",
    anyOrder: "Keine Befehle",
    shippedAt: "Versandt um",
    sku: "SKU",
    status: {
      created: "Erstellt",
      confirm_order: "Bestellung bestätigen",
      ready_for_shipment: "Versandfertig",
      rejected: "Abgelehnt",
      processed: "Verarbeitet",
      shipped: "Versendet",
      returned: "Ist zurückgekommen",
      finished: "Fertig",
    },
    details: {
      title: "Bestellungsdetails",
      description: "Überprüfung und Verwaltung neuer Aufträge",
    },
    date: "Bestelldatum",
    products: "Produkte",
    quantity_short: "Stk",
  },
  orders: "Bestellungen",
  hunter: {
    title: "Hunter",
    description:
      "Hochwertige Maschinen und Ausstattungen für Ihre Werkstatt sind eine Investion in Ihren Betriebserfolg. Nutzen Sie Ihre BRIDGESTONE <span class='text-danger'>PLUS</span> Prämienpunkte, um die Anschaffung von HUNTER Werkstattmaschinen zu vergünstigen. Die von Ihnen eingesetzten Prämienpunkte werden direkt mit HUNTER verrechnet und wirken sich so auf den Anschaffungspreis aus.",
    priceInfo: "Nettopreis inkl. Fracht und Inbetriebnahme/Einweisung",
    pointsInfo: "Nettopreis in Punkten",
    investInfo:
      "Ab-oder anrechnung der punkte über eine investitionsunterstützung möglich.",
    contactInfo:
      "Sollten Sie Fragen zum Vorgehen haben, bitten Sie uns dazu persönlich zu kontaktieren. Kontakt",
    specification: "Spezifikationen",
    pointDiscount: "Dies entspricht {price} EURO",
    form: {
      title: "Ich interessiere mich für",
      subtitle: "Ich möchte Punkte von meinem Punkteguthaben einsetzen",
      description:
        "Nach Tätigung Ihrer Anfrage, werden wir Kontakt mit Ihnen aufnehmen. Selbstverständlich stehen wir Ihnen auch jederzeit bei Fragen zur Verfügung.",
    },
  },
  intro: {
    step1: {
      title: "PERSONENBEZOGENES",
      description:
        "Hier finden Sie Informationen zu Ihrem Plus-Konto und Ihr Plus-Postfach.",
    },
    step2: {
      title: "PUNKTEÜBERSICHT",
      description:
        "Hier finden Sie Ihre Punkteübersicht. Sie können Ihre Performance der letzten zwölf Monate einsehen und sich mit Punkten Prämien sichern.",
    },
    step3: {
      title: "AUF DEM LAUFENDEN BLEIBEN",
      description:
        "Lassen Sie sich die Funktionen von Bridgestone Plus erklären und erfahren Sie, was noch alles möglich ist.",
    },
  },
  wholesaler: {
    dashboard: {
      title: "{name} Dashboard",
      extraTitle: "WHOLESALER-DASHBOARD",
      description:
        "Herzlichen willkommen auf Ihrem Dashboard. Hier können Sie aktuelle Kennzahlen und teilnehmende Betriebe aus Ihrer Kundschaft einsehen.",
      overview: {
        title: "Übersicht teilnehmende Kunden",
        description:
          "Betriebe, die sich bei BRIDGESTONE PLUS mit angemeldet haben und die wir über die Kundennummer Ihren Unternehmen zuordnen können.",
        month: "Neu diesen Monat",
        year: "Neu dieses Jahr",
        all: "Gesamt",
      },
      credits: {
        title: "Punktegutschriften {name}",
        description:
          "Prämienpunkte, die teilnehmenden Betrieben aufgrund der von Ihnen hochgeladenen Absatzzahlen zugewiesen haben. In dieser Ansicht sind reguläre Punkte ohne Sonderaktionen dargestellt.",
        month: "Letzter Monat",
        year: "Aktuelles Jahr",
        prev_year: "Gesamt",
        prev_month: "Vormonat",
        all: "Gesamt",
        allDealers: "Alle Händlerpunkte",
      },
      details: {
        title: "Teilnehmende Kunden im Detail",
        description:
          'Nachfolgend sind die Betriebe aufgeführt, die sich mit einer {name} Kundennummer auf BRIDGESTONE <span class="text-danger">PLUS</span> registriert haben und die Ihnen als Zuständigem/r zugewiesen sind. Nutzen Sie einfach Sortierfunktionen für eine andere Reifenfolge oder die Suchmaske.',
      },
      lastImport:
        'Letzter Import von Absatzzahlen:  <span class="text-danger">{date}</span>',
      loadMore: "Weitere 20 händler laden",
      tyres: {
        title: "Reifen",
        description: "Bon Programmteilnehmern gekaufte Reifen",
      },
      reload: "Neu laden",
    },
  },
  staff: {
    dashboard: {
      title: "Aussendienst Dashboard",
      description:
        "Herzlichen willkommen auf Ihrem Dashboard. Hier können Sie aktuelle Kennzahlen und teilnehmende Betriebe aus Ihrer Kundschaft einsehen.",
      overview: {
        title: "Übersicht teilnehmende Kunden",
        description:
          'Betriebe, die sich bei BRIDGESTONE <span class="text-danger">PLUS</span> mit angemeldet haben und die wir über die Kundennummer Ihnen zuordnen können.',
        month: "Neu diesen Monat",
        year: "Neu dieses Jahr",
        all: "Gesamt",
      },
      credits: {
        title: "Punktegutschriften",
        description:
          "Prämienpunkte, die teilnehmenden Betrieben aufgrund der übermittelten Absatzzahlen zugewiesen haben.",
        month: "Letzter Monat",
        year: "Aktuelles Jahr",
        prev_year: "Gesamt",
        prev_month: "Vormonat",
        allDealers: "Alle Händlerpunkte",
        allPoints: "Alle Punkte",
      },
      details: {
        title: "Teilnehmende Kunden im Detail",
        description:
          'Nachfolgend sind die Betriebe aufgeführt, die sich mit einer Bridgestone Kundennummer auf BRIDGESTONE <span class="text-danger">PLUS</span> registriert haben und die Ihnen als Zuständigem/r zugewiesen sind. Nutzen Sie einfach Sortierfunktionen für eine andere Reifenfolge oder die Suchmaske. <b>Hinweis:</b> Wenn Sie auf den Punktestand klicken, gelangen Sie zum detaillierten Kontoauszug.',
      },
      lastImport:
        'Letzter Import von Absatzzahlen:  <span class="text-danger">{date}</span>',
      kickback: {
        description:
          "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
      },
      tyres: {
        title: "Reifen",
        description: "Bon Programmteilnehmern gekaufte Reifen",
      },
      reload: "Neu laden",
      exports: {
        title: "Exportierte Excels",
        head: {
          name: "Name",
          status: "Status",
        },
      },
    },
  },
  newsFeed: {
    more: "Mehr Informationen bei",
  },
  investment: {
    title: "Investitionsunterstützung",
    description:
      "Bridgestone unterstützt Sie individuell auch bei Ihren betrieblichen Investitionen. Egal ob bei der Anschaffung von Maschinen oder Werkstattausstattung, bei Werkstatt-Ersatzfahrzeugen oder auch bei Marketingaktivitäten wie Anzeigen- oder Onlinebannerschaltungen etc. - setzen Sie Ihre BRIDGESTONE PLUS Prämienpunkte zur Refinanzierung Ihrer Investitionen ein. Reichen Sie einfach nach erfolgter Investition die Rechnung des jeweiligen Anbieters hier ein und geben Sie an, wie viele Ihrer Prämienpunkte Sie hier einsetzen möchten. Folgen Sie der unten beschriebenen Anleitung.",
    description_old:
      "Investitionsunterstützung für Werkstattausstattung Werbekostenzuschuss für Marketingprojekte",

    info: {
      paragraph2_old:
        "Bringen Sie Ihre Werkstattausrüstung oder Ihren Verkaufsraum auf den neuesten Stand oder betreiben Sie Werbung zur besseren Vermarktung Ihrer Produkte.Bitte nennen Sie uns dazu den Punktewert, den Sie für diese Prämie aufbringen möchten. Der Mindestpunkteaufwand beträgt 1.250 Punkte.Wert pro Punkt = 0,25 EUR",
      paragraph2:
        "Sie setzen Ihre gewünschte Investition um und gleichen die Rechnung des Drittanbieter aus.",
      paragraph3_old:
        "Zur Abrechnung der Prämie benötigen wir Ihre Rechnung in Höhe der abgerufenen Punkte (Anzahl Punkte x 0,25 € = Nettorechnungsbetrag) und eine Kopie der Originalrechnung. Eine Musterrechnung finden Sie",
      paragraph3:
        "Im Abschluss stellen Sie hier auf dieser Seite im Anfragefeld rechts den Antrag auf Bezuschussung",
      paragraph4_old:
        "Wir bitten Sie uns dazu persönlich zu kontaktieren, um die weiteren Schritte einzuleiten.",
    },
    excludeText:
      "Bitte haben Sie Verständnis, dass Investitionen in Angebote des direkten Wettbewerbs ausgeschlossen sind.",
    here: "hier",
    contactPerson: "Ansprechpartnerin",
    email: "Email",
    phone: "Tel",
    payInfo: "Auszahlung kann bis zu 8 wochen dauern!",
  },
  notice: "Hinweis",
  noticeDescription:
    "Bei Vorliegen eines Sach- und/oder Personenschadens wenden Sie sich bitte direkt an Bridgestone Europe NV/SA Niederlassung Deutschland Tel.: 0049-6172-408-435, E-Mail: <a href='mailto:{email}'>{email}</a>, da diese einer gesonderten Abwicklung unterliegen.",
  yourEmail: "Ihre E-Mailadresse",
  addressEndCustomer: "Anschrift endkunde",
  tireSizeExample: "Reifengröße (z.B. 215/60/16)",
  profileDesignation:
    "Profilbezeichnung inc. Spezifikation ( z.B.: RE050A, R168 Eco, ...)",
  speedLoadIndex: "Geschwindigkeits- / Lastindex",
  restDay: "Ruhetag",
  breakTimes: "Pausenzeiten",
  claimFrom: {
    pdf: {
      number: "Formular-Nr",
      tireSizeExample: "Reifengröße",
      dot: "DOT",
      vehicleModelType: "Fahrzeugmodell/Typ",
      enginePower: "Motorleistung (KW)",
      speedLoadIndex: "Geschw.Index",
      profile: "Profil",
      damage: "Schaden",
      replacementStamp: "Ersatzmarke",
      personalInjury: "Personenschaden",
      tiresReplaced: "Reifen ersetzt",
      agb: "AGB",
      clerkName: "Name des Sachbearbeiters",
      complaintReason: "Beanstandungsgrund",
      complaintReasonText: "Beanstandungsgrund Text",
      vehicleTyres: "Fahrzeug/Reifen",
    },
  },
  fuelCalculator: {
    oldLabel: "ALTES KRAFTSTOFFLABEL",
    selectOldLabel: "Labelwert wählen",
    tyreLife: "Gesamtlaufleistung (des reifensatzes IN KM)",
    tyreLifeLabel: "Gesamtlaufleistungen eingeben, z.B. 40.000",
    fuelPrice: "Spritpreis (pro Liter IN EUR)",
    fuelPriceLabel: "Spritpreis eingeben, z. B. 1,82",
    newLabel: "NEUES KRAFTSTOFFLABEL",
    selectNewLabel: "Labelwert wählen",
    fuelConsumption: "Spritverbrauch (des fzg pro 100 km in liter)",
    fuelConsumptionLabel: "Spritverbrauch eingeben, z. B. 7,8",
    table: {
      euroSave: "Ersparnis in der gesamtlaufzeit",
      fuelSavePercent: "änderung des spritverbrauches",
      newConsumption: "Neuer spritverbrauch Auf 100 km",
      fuelSaveLiter: "Spritverbrauch sinkt Auf 100 km um",
      fuelSaveTotalLiter: "Spritverbrauch sinkt In der gesamtlaufzeit um",
    },
    results: "Ergebnisse und einsparpotentiale",
    please: "bitte Hinweise unter den Ergebnissen BEACHTEN",
    calcHeader: "Geben sie hier die eckdaten zu reifen und fahrzeug ein:",
    mainDesc:
      "Mit dem <b>Spritspar-Rechner</b> können Sie einfach und direkt die Ersparnis berechnen, die eine bessere Rollwiderstands-Klasse bei neuen Reifen im Vergleich zu einer schlechteren Klasse ermöglichen kann. Geben Sie hierfür einfach die Werte in das Formular ein.<b>Das Ergebnis bezieht sich auf die Gesamtlaufleistung und bietet Ihnen ein zusätzliches starkes Argument im Verkaufsgespräch – empfehlen Sie die Premium Reifen von Bridgestone mit optimiertem Rollwiderstand!",
    description:
      "Reifen mit geringem Rollwiderstand, die richtig aufgepumpt sind (gemäß Herstellerangaben), können bis zu 10 % Einsparungen beim Kraftstoff bewirken. Dies führt zu finanziellen Einsparungen bei den Betriebskosten oder ermöglicht es dem Fahrer beispielsweise bei Elektrofahrzeugen, eine weitere Strecke zurückzulegen, bevor er tanken oder aufladen muss. Die Rollwiderstandsklasse reicht von A (am effizientesten) bis E (am wenigsten effizient). Je höher die Energieklasse, desto geringer ist der Rollwiderstand.",
    noticeText:
      "Basierend auf der Datengrundlage der Europäischen Kommission wurde eine maximale Kraftstoffersparnis über alle Labelklassen (Label A gegenüber Label E) von 10% angenommen. Dies ist ein Maximalwert, der insbesondere voraussetzt, dass man die Reifen mit den vom Fahrzeug- bzw. Reifenhersteller angegebenen optimalen Luftdrücken fährt (Mehr Infos hierzu auf der Website der Europäischen Kommission: <a href='https://commission.europa.eu/energy-climate-change-environment/standards-tools-and-labels/products-labelling-rules-and-requirements/energy-label-and-ecodesign/energy-efficient-products/tyres_en'>https://commission.europa.eu/energy-climate-change-environment/standards-tools-and-labels/products-labelling-rules-and-requirements/energy-label-and-ecodesign/energy-efficient-products/tyres_en</a>). Auf Grundlage der maximalen Kraftstoffersparnis ergibt sich bei Annahme einer linearen Reduzierung ein Unterschied von etwa 2,5% pro Änderung in die nächstbessere Labelklasse. Dieser Prozentsatz wird vom anzugebenen Ausgangswert des Benzinverbrauchs durch die Rechnungslogik entsprechend in Abzug gebracht. Beispiel: Als Verbrauchswert sind 7,0 l pro 100 km angegeben worden. Errechnet werden soll die Kraftstoffersparnis bei einem Wechsel von Label C auf Label A. Basierend auf obiger Logik ergibt sich eine solche in Höhe von 2,5% * 2 = 5%. Unter Einbeziehung des angegebenen Verbrauchswertes ergibt sich damit folgender neuer Verbauchswert: 7,0 l * (100 % - 5 %) = 6,65 l und damit eine Einsparung von 0,35 l / 100 km.Bridgestone weist ausdrücklich darauf hin, dass es sich hinsichtlich der vorstehend in Ansatz gebrachten prozentualen Änderung um einen theoretischen Wert handelt, der den oberen Bereich möglicher Kraftstofferspaarnis durch Rollwiderstand des Reifens widerspiegelt. Er dient folglich lediglich als Annäherung und wird in der Praxis nicht immer erreichbar sein, da der Kraftstoffverbrauch eines Fahrzeuges (und entsprechend auch dessen Einsparung) neben dem reinen Rollwiderstand des Reifens noch von vielen weiteren Faktoren (bspw.: Fahrstil, Geschwindigkeit, Luftdruck der Reifen, Reifen- und Umgebungstemperatur, Luftwiderstand des Fahrzeugs, Fahrzeugbeladung, Straßenbedingungen sowie Fahrwerks-  und Fahrzeugeinstellungen) abhängt, welche sich auch untereinander nochmals beeinflussen. Die Ergebnisse der durchgeführten Berechnungen stellen somit lediglich eine unverbindliche, näherungsweise Einschätzung dar, für deren Richtigkeit und Präzision Bridgestone keinerlei Haftung übernimmt.",
  },
  legalNotice: "Rechtliche Hinweise",
  addCsNumber: {
    body: "Sind Sie sicher, dass Sie diese Kundennummer speichern möchten? Durch die Aktion werden Bearbeitungsdaten blockiert, bis der Administrator sie genehmigt.",
  },
  priceDescription:
    "Laden Sie aktuelle Preislisten herunter für Ihren Gebrauch.",
  pricatDescription:
    "Hier erhalten Sie Pricat Dateien für Ihre Warenwirtschaft.",
  pricat: {
    title: "Pricat",
    description:
      "Laden Sie hier CSV- und TEXT- Datensätze für Ihre Warenwirtschafts- und EDV-Systeme & Co herunter.",
  },
  fillProfile:
    "Füllen Sie das Profil aus, um das Zertifikat herunterladen zu können,",
  certificate: {
    header: "ZERTIFIKAT",
    atCourse: "hat erfolgreich am Kurs",
    takePart: "teilgenommen.",
    contains: "BESTANDTEILE DES KURSES",
  },
  afterTraining: {
    congratulations: "Glückwünsche",
    allAnswer: "Du hast alle Fragen beantwortet korrekt",
    points: "Sie erhalten {points} auf Ihre Konto sofort!",
    clickToProfile: "klicken Sie auf den Link",
  },
  kickback: {
    title: "Kickback fee",
    word: "Kick-back",
    description:
      "Den teilnehmenden Unternehmen werden Kickback-Gebühren auf Basis der übermittelten Umsatzzahlen gutgeschrieben.",
  },
  externalLinks: {
    tyreBuy: "Reifen bestellen",
  },
  loginPageSteps: {
    welcome:
      "Herzlich willkommen bei BRIDGESTONE PLUS – dem Mehrwert-Portal von Bridgestone.",
    step1: {
      title: "Neu hier?",
      description:
        "Sie sind das erste Mal auf dem Portal BRIDGESTONE <span class='text-danger'>PLUS</span>?<br /><br />Dann registrieren Sie sich jetzt!",
      actionBtn: "JETZT REGISTRIEREN",
    },
    step2: {
      title: "TYRE<span class='text-danger'>CLUB</span> Händler",
      description:
        "Sie haben bereits Zugangsdaten für den ehemaligen Bridgestone TYRE<span class='text-danger'>CLUB</span>?<br /><br />Dann setzen Sie hier Ihr neues Passwort für die E-Mail-Adresse, die Sie für den TYRE<span class='text-danger'>CLUB</span> verwendet haben.",
      actionBtn: "NEUES PASSWORT SETZEN",
    },
    step3: {
      title: "Willkommen bei BRIDGESTONE <span class='text-danger'>PLUS</span>",
      description:
        "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an.</br><b>Sind Sie neu hier?</b></br>Erstellen Sie dann zunächst Ihr neues Benutzerkonto über die Funktion REGISTRIEREN.</br>Sie werden dann automatisch eingeloggt.",
      actionBtn: "ANMELDEN/REGISTRIEREN",
    },
    info: 'Brauchst du Hilfe? Bitte kontaktieren Sie uns: <a href="mailto:{email}">{email}</a>',
  },
  marketingModal: {
    title: "AGBs & Teilnahmebedingungen",
    description:
      "Allgemeine Geschäftsbedingungen der Bridgestone Europe NV/SA Niederlassung Deutschland (nachfolgend “Bridgestone” genannt) für das Portal BRIDGESTONE PLUS, im Folgenden 'BS PLUS' genannt.",
    content:
      "General Terms and Conditions of Bridgestone Europe NV/SA, Netherlands Branch, with registered office in Nieuwe Weideweg1 NL- 6121 PD Born Netherlands - K.v.K. 66469767 (hereinafter referred as 'Bridgestone').",
    point1Title: "Participation",
    point1Desc:
      "The General terms and conditions does not imply any commitment of the Participant to reach a market share set by Bridgestone, nor does it oblige the Participant to sell exclusively the Bridgestone’s tires. It is understood that the Participant remain free to determine their own resale prices for tires without any restrictions, even in the presence of any recommendations, which shall however be understood as non-binding. The requirements for participation in BS PLUS that are binding for the participating company with which the agreement was concluded (hereinafter referred as 'Participant'). The Participant acknowledges that admission to participation in BS PLUS is at the discretion of Bridgestone, and no claims against Bridgestone for admission are valid. The transfer or assignment of Participant accounts is expressly prohibited unless otherwise specified by Bridgestone. Pledging the Participant account is not allowed. Participants are responsible for promptly updating their personal data online. Failure to comply with this obligation may result in additional costs, delays, increased risk of damage or loss of prizes, and other associated damages.",
    point2Title: "Kickback fees and crediting of marketing points",
    point2Desc:
      "Entry level for pay-out is that the Participant buys a minimum volume of sixty (60) Bridgestone-branded car, light truck, 4x4 summer, winter and all-season tyres at the selected distributors from 1st  April 2024 till 31st December 2024. If the minimum annual volume is not reached, no kickback fees will be credited to the Participant. From 2025, the entry level for pay-out will be one hundred twenty (120) Bridgestone-branded car, light truck, 4x4 summer, winter and all-season tyres at the selected distributors from 1 January till 31 December. Points-relevant and accounting periods for the calculation of points as of 2025: January - December of each year. The kick-back fees and marketing points does not apply to 2A goods, demo tires, non-active/inactive pricelist EAN’s... Unused points from the previous expire on March of the next year. For example unused points from 2024 expire on March 01,2025. Points will be credited to the Participant exclusively at the initiation of Bridgestone and in strict accordance with the conditions set out in the Conditions Tab in Bridgestone plus platform. The number of points granted per type of tyres are accessible in the BS platform. https://plus.bridgestone.nl",
    point3Title: "Rewards",
    point31Title: "Marketing Points",
    point31Desc:
      "The Participant has nominated an employee or vicarious agent to retrieve the rewards on its behalf. This person has access to the points account of the Participant. Participants have the option to redeem the credited points for offered rewards in kind and/or services. Payment of the equivalent cash value of the accumulated points is not permitted, unless expressly stated in the rewards system. No interest accrues on the Participant's account. Points can be redeemed if the points account displays the necessary balance for the specific reward. Participants do not have a guaranteed entitlement to any particular reward, and redemption is subject to availability while stocks last. The Participant has the option to redeem the credited points for the offered rewards in kind and/or services. The payment of the equivalent cash value of the points collected points is not permitted, unless expressly stated in the rewards system. No interest will be paid on the Participant's account. The points collected can be redeemed if the points account displays the necessary balance for the specific reward. Participants do not have a guaranteed entitlement to any particular reward, and redemption is subject to availability while stocks last. Bridgestone retains the right to rectify any evident mislabeling of rewards. Redeemed points are non-transferable and cannot be exchanged for additional points or different rewards. Once the order has been placed, the Participant will promptly receive a confirmation of receipt.  Bridgestone will then promptly verify all relevant data and assess the availability of the reward. Unless explicitly   stated otherwise, all performance, dimension of the rewards remain as described. Redeemed points cannot be exchanged for points or rewards. Once the order has been placed, the participant will promptly receive a confirmation of receipt. Bridgestone will then promptly check all relevant data and the availability of the reward. Unless explicitly stated otherwise, all performance, dimension, weight, and size specifications are approximate values and are provided for descriptive purposes only; they do not constitute guaranteed properties. Delivery times will be communicated separately to the Participant after the order has been placed. In the event that the ordered item is unavailable or cannot be delivered, Bridgestone retains the right to send the Participant a comparable, similar item or to cancel the order. The marketing points must be used by the Participant before March 31st of the following year, or they will be forfeited.",
    point32Title: "Kickback fee",
    point32Desc:
      "The Participant will receive kickback fees upon the achievement of the commitments made, either directly from Bridgestone, or from a selected service provider. The kickback fee accrues when the Conditions of Participation are accepted by the Participant through tire orders facilitated by distributors appointed by Bridgestone. Bridgestone or a selected service provider disburses the kickback fees to the Participant once annually, subsequent to a verification of the accuracy of the collected data and subject to the fulfillment of the aforementioned commitments. This disbursement transpires within the first quarter of the subsequent year. For example: the kickback fee for the year 2024 is disbursed in the first quarter of 2025. This process is executed automatically subsequent to a comprehensive review of the Participant's tire orders and associated data. The Participant receives the kickback fees directly from Bridgestone or from a selected service provider. Concurrently, the Participant will be provided with a document suitable for inclusion in its financial records.",
    point4Title: "SCORE / PASSWORD",
    point4Desc:
      "The points are registered under the Participant's number. Any objections to the accuracy or completeness of the points score must be made in writing within one month of becoming awareof them. Failure to raise an objection in good time shall be deemed to constitute approval of the score. Even after the deadline has expired, a correction of the reported score may be requested if the Participant can unequivocally  demonstrate the inaccuracy and/or incompleteness. The Participant is responsible for ensuring that that its password remains confidential, and in the event of suspicion that another person has obtained knowledge of the password or any other misuse, the Participant must promptly change their password or promptly notify Bridgestone.",
    point5Title: "DEFECTS/DEFICIENCIES",
    point5Desc:
      "Defects in the delivered items must be reported immediately in writing. Otherwise, the statutory provisions shall apply.",
    point6Title: "TERMINATION",
    point6Desc:
      "Participation in BS PLUS is voluntary, and participants may choose to terminate their involvement at any time by notifying Bridgestone. It is important to note that the termination of participation does not impact the redemption of accumulated points. Bridgestone retains the right to exclude a participant from the program for justifiable reasons. ",
    point7Title: "LIABILITY",
    point7Desc:
      "The Participant assumes at its own risk all obligations in connection with its business organization relating, by way of example, to employment and self-employment relations, including insurance obligations, the correct fiscal and administrative management of the company, and the observance of current environmental, safety, and accident prevention regulations. Except in the case of willful misconduct or gross negligence, Bridgestone shall not be liable for any damage caused by the Participant in the performance of the activities referred to in the Conditions. ",
    point8Title: "MODIFICATION OF THE Conditions of Participation AND ORDERING",
    point8Desc:
      "Bridgestone reserves the right to discontinue the rewards system subject to a notice period of 3 months, in the event of an important reason also without observing such a notice period, while reasonably safeguarding the interests of the Participant. Bridgestone also reserve the right to amend or supplement the terms and conditions insofar as this is necessary in the interests of simpler and more secure processing and in particular to prevent abuse.The Participant will be notified of any changes in advance. An amendment and/or supplement shall be deemed to have been approved if it is not terminated within one month of becoming known or if the Participant takes part in the rewards program again after this period has expired. ",
    point9Title: "CONFIDENTIALITY",
    point9Desc:
      "The Participant undertakes, for himself and for his employees and collaborators, not to divulge to third parties and not to use, information of a confidential nature, such as technical information, advertising or financial data, commercial information, know-how, prices, costs, administrative information, operational present and future projects, Bridgestone strategies, or any other information which at the time of disclosure is not yet in the public domain. This clause must also be understood as binding for the subsequent five years from the termination of the participation. ",
    point10Title: "DATA PROTECTION",
    point10Desc:
      "Bridgestone, its selected service provider and the Participant undertake to comply with any obligations under Regulation (EU) 2016/679 of the European Parliament and of the Council of 27 April 2016 on the 'protection of individuals with regard to the processing of personal data and on the free movement of such data' (hereinafter 'GDPR') a, as well as the relevant national regulations and the measures of the Data Protection Authority. In order to participate to BS PLUS, various personal data must be collected, stored and used. This data is required in order to open a personal points account for the Participant and to be able to send them information relating to the rewards program. The mandatory data required for participation includes company name, surname, first name, position in the company, full postal address, telephone number, BTW number, bank account number and e-mail address. For the purpose of processing and implementing BS PLUS, the Participant's data will be stored and used by TAKTZEIT, Bridgestone or a service company commissioned by TAKTZEIT. Bridgestone and TAKTZEIT also undertake to comply with the statutory data protection regulations. Data will only be passed on to third parties if these third parties serve as vicarious agents, e.g. for the processing of a rewards order. By participating in the rewards program, the Participant declares his/her consent by confirming this, which can be revoked in writing at any time. With the declaration of consent, the Participant receives the corresponding newsletter. It is possible to unsubscribe from the newsletter at any time via the menu item 'Contact > Unsubscribe newsletter'",
    point11Title: "Intellectual property",
    point11Desc:
      "The Participant acknowledges and accepts that all intellectual property rights (hereinafter referred to as 'IPR'), both present and future, relating to, subsisting in or in any way connected with the BS Plus are the property of the Bridgestone group. The Participant is permitted to use IPRs solely in connection with its business of selling tyres and providing services. Internal and external point of sale recognition projects must be approved by Bridgestone. It is understood that if the Participant intends to use the IPR in any form of communication to the public, the promotional and advertising material prepared for the purpose must be submitted to Bridgestone for prior approval. Bridgestone will have the right to check at any time, by means of an on-site inspection at the premises of the Participant, that the rules for the use of IPRs are respected. The Participant may not in any way assign the use of the IPRs and/or otherwise dispose of them to third parties. ",
    point12Title: "FINAL PROVISIONS ",
    point121Desc:
      "Amendments or additions to these terms and conditions must be made in writing. This also applies to the waiver of this written form requirement.",
    point122Desc:
      "The Dutch Law shall apply to the exclusion of the UN Convention on Contracts for the International Sale of Goods. For any dispute connected with or arising out of the Commitment Letter, the Parties elect the exclusive jurisdiction of the Rotterdam Court, The Netherlands.  ",
    point123Desc:
      "Should individual provisions of these terms and conditions be ineffective or contradict the statutory regulations, this shall not affect the remainder of the contract.The invalid provision shall be replaced by the contracting parties by mutual agreement by a provision which comes closest to the economic sense and purpose of the invalid provision in a legally effective manner. ",
    point1234Desc:
      "The aforementioned provision applies correspondingly in the case of any gaps or omissions. Verbal agreements are deemed invalid, and only the Conditions of Participation outlined in the General Terms and Conditions (GTCs) shall be considered binding. ",
    point13Title: "RETURN POLICY ",
    point13Desc:
      "The Participant has a 14-day right of return. In this case, he/she must write to: Bridgestone Europe NV/SA Netherlands Branch,  with registered office in Nieuwe Weideweg1 NL- 6121 PD Born Netherlands. Bridgestone will provide the participant with the necessary instructions for the return process. The return period commences upon the Participant's receipt of the goods. In the event of a return from a delivered product, the purchaser is responsible for covering the return costs if the delivered goods match the ordered items. The points utilized by the Participant for the redeemed reward will be reinstated in the points account. The right of return is not applicable to items that have been customized to specifications or are clearly tailored to personal requirements.",
    footer: "Bitte laden Sie das Dokument für Ihre Unterlagen herunter. ",
  },
  commitmentLetter: {
    title: "Commitment letter",
    short_description: "Voer hier uw contact- en bedrijfsgegevens in.",
  },
  kickbackInfo: {
    title: "Erläuterung der Kickback-Gebühr und der Punkte",
    short_description:
      "Hier können Sie sehen, wie Sie Kickback-Gebühren und Marketingpunkte verdienen.",
    description:
      "Mit <b>BRIDGESTONE PLUS</b> sammeln Sie Punkte und eine Kickback-Gebühr für alle Bridgestone-Reifen, die Sie bei den von Bridgestone benannten Händlern bestellen. Unten sehen Sie, wie Sie Punkte und Kickback-Gebühren sammeln. <br /><br />><b>Regeln:</b><ul><li>Für jeden Bridgestone-Reifen erhalten Sie Marketingpunkte, die Sie im Shop ausgeben können. Die Anzahl der Punkte, die Sie pro Reifen erhalten, hängt von der Zollgröße des Reifens ab.</li><li>Die Rückschlagsentschädigung fällt im Laufe des Jahres durch Reifenbestellungen bei den von Bridgestone beauftragten Händlern an. Bridgestone zahlt dem Teilnehmer die Kickback-Entschädigung einmal jährlich nach Prüfung der Richtigkeit der erhobenen Daten und unter der Voraussetzung, dass Sie mindestens 120 Reifen pro Jahr gekauft haben. Diese Auszahlung erfolgt im ersten Quartal des Folgejahres. Beispiel: Die Auszahlung der Kickback-Entschädigung für das Jahr 2024 erfolgt im ersten Quartal 2025. Dieser Vorgang erfolgt automatisch nach Prüfung der Reifenbestellungen und Ihrer Daten. Sie erhalten die Kickback-Entschädigung direkt von Bridgestone oder über seinen externen Partner. Sie erhalten außerdem ein Dokument, das zur Aufnahme in Ihre Finanzverwaltung geeignet ist.</li></ul>",
    tableFooter:
      "Keine Kick-Back-Gebühr für die anderen Produktgruppen: TBR, MC, OTR, AG",
    withdraw: "Voor het uitbetalen van de kickback fee",
  },
  pause: "PAUSE",
  myProfile: "Mein Profil",
  tyreAmount: "Reifenmenge",
  rewardsOverview: {
    titlePoints: "Marketingpunkte (1 Punkt = 0,25 Euro)",
    titleKickback: "Kick-Back-Gebührenbonus in Euro",
    footerPoints:
      "Keine Vermarktungspunkte für die anderen Produktgruppen: TBR, MC, OTR, AG",
    kickbackPoints:
      "Keine Kickback-Gebühr für die anderen Produktgruppen: TBR, MC, OTR, AG",
    groupLevel: "Group Level",
  },
  group: "Groupen",
  major: "Groep",
  strategicPartners: {
    cardTitle: "Kontakt zu unseren strategischen Partnern",
    title: "Kontakt zum Vertriebspartner",
    description:
      "Wir sind bereit für Sie! Nachfolgend finden Sie die Details Ihrer Großhändlerkontakte.",
    short_desc:
      "Haben Sie Fragen zu Ihren Reifenbestellungen bei angeschlossenen Händlern? Klicken Sie unten für die Kontaktdaten",
  },
  onlineVisibility: {
    box: { title: "Online Sichtbarkeit" },
    title: "Online Sichtbarkeit",
    description:
      "Steigern und steuern Sie Ihre digitale Sichtbarkeit auf POS-Level mit UBERALL",
    category_title: "uberall - verbesserung der digitalen sichtbarkeit",
    category_description:
      "Nutzen Sie jetzt Ihre Prämienpunkte, um ihr Digitales Standortmarketing auf die nächste Stufe zu heben. Mithilfe der Plattform uberall unterstützt Bridgestone Handelspartner bei der Optimierung der Online-Präsenz, um mehr Besucher zu generieren. Und das auf über 100 Plattformen wie Google, Facebook, Bing oder Trustpilot.",
    content: "Nutzen Sie jetzt die Vorteile von uberall:",
    point1: "Optimierung der Online-Sichtbarkeit",
    point2: "Bequeme Steuerung & Kontrolle von POS-Standorten",
    point3:
      "Lokale Sichtbarkeit, Bewertungen und Social Media Content verfolgen",
    footer:
      "Um detaillierte Informationen zu erhalten und einen ersten Eindruck von uberall zu gewinnen, schauen Sie sich das folgende Video an.",
    period: "Laufzeit: 1 Jahr",
    form: {
      title: "So nutzen Sie uberall für Ihr Unternehmen:",
      point1: "Für 480 Punkte ein Jahres-Abo abschließen",
      point2: "Nach interner Prüfung erhalten Sie eine Bestätigung",
      point3: "keine automatische Verlängerung",
      pointDiscount: "Punkte in einem {price} EUR von für folgende",
      howMuch: "Wie viele Punkte möchten sie einsetzen?",
    },
    uberall: {
      title: "UBERALL ABONNEMENT",
    },
  },
  media: {
    title: "Media-Pakete & Logos",
    short_description:
      "Hier finden Sie Daten für Social Media, Instore-TV und mehr.",
    description:
      "In unserer Medienbibliothek stehen Ihnen eine Vielzahl von Medien unserer Marken Bridgestone und Firestone sowie weiteren Reifenlösungen zur Verfügung. Nutzen Sie verschiedene Filteroptionen oder geben Sie gezielte Suchanfragen in das Suchfeld ein, um Ihre gewünschten Medien schnell zu finden.",
  },
  sortBy: {
    default: "Sortieren nach",
    desc: "Sortieren nach: Neueste",
    asc: "Sortieren nach: Älteste",
    name: "Namen",
    date: "Datum",
    choiceBy: "Auswahl sortieren nach",
  },
  bridgestoneProductBrochures: {
    title: "Bridgestone Produkte",
    description:
      "Laden Sie hier aktuelle Broschüren und Flyer zu unseren Bridgestone Reifen für Pkw, SUV und Transporter herunter.",
    files: {
      desc1: "PKW, SUV - Winter",
    },
  },
  testResult: "Testergebnisse",
  productOverview: "Produktübersicht",
  summary: "Zusammenfassende",
  information: "Information",
  brochure: "Broschüre",
  makeChoice: "Treffen Sie hier Ihre Wahl",
  winterIn: "Der Winter ist da",
  summerIn: "Hinein in den Sommer",
  allSeasonIn: "Die ganze Saison über",
  haveQuestion: "Sie haben eine Frage?",
  contactUs: "Dann senden Sie uns gerne eine Mail an",
  at: "bei",
  tyreBox: {
    title: "Tyres",
    totalAmount: "Total tyres",
    target: "Your target",
    entry: "Your entry",
  },
  firstStop: {
    description:
      "Auf dieser Seite finden Sie die Garantiebedingungen und die Erklärungsformulare zur First Stop Reifengarantie. Hinweis: Aufgrund der Verfahrensanpassung im Jahr 2024 gibt es 2 unterschiedliche Verfahren basierend auf dem Kaufdatum des Reifens.",
    section1: {
      title: "Real Garant-Verfahren (Reifen gekauft bis 29.02.2024)",
      description:
        "Das Verfahren über Real Garant gilt für Reifen, die bis zum 29. Februar 2024 gekauft wurden. Nachfolgend können Sie die Bedingungen und das Erklärungsformular herunterladen",
    },
    section2: {
      title: "Erster Stopp-Vorgang (Reifen gekauft ab 1.3.2024)",
      description:
        "Im Neuzustand werden nur die Reifen erstattet. Der Verbraucher trägt die Kosten für die Montage und den Umweltbeitrag des neu zu montierenden Reifens. First Stop erstattet den Kaufpreis des Reifens. Die Höhe der Montagerate können Sie frei bestimmen Geben Sie dies bitte an. Auf der neuen Rechnung immer gesondert ausgewiesen.",
      footer:
        "Der Rest des Schadenbearbeitungsverfahrens ändert sich kaum. Nachfolgend können Sie die Bedingungen, das Antragsformular und das Verfahren herunterladen.",
    },
  },
  languageSelect: {
    title:
      "Willkommen bei <b>BRIDGESTONE PLUS</b> - dem Premium-Portal von Bridgestone.",
    label: "Sprachauswahl",
    description:
      "Bitte wählen Sie Ihre Sprache/Wählen Sie Ihre Sprache/Wählen Sie Ihre Sprache aus",
  },
  current_tyres_amount: "Reifenmenge",
  current_points: "Punktestand",
  current_kickbacks: "Kick-back",
  phoneShortCut: "Tel.",
  mediaCategories: {
    products: "Produkte",
    brand_and_solutions: "Marke & Lösungen",
    season_and_promotions: "Saison & Aktionen",
    format: "Format",
    cars_and_vans: "Pkw & Transporter",
    truck_and_buses: "Lkw & Bus",
    motorcycle: "Motorrad",
    agriculture: "Landwirtschaft",
    construction_machinery: "Baumaschinen",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleet Care",
    webfleet: "Webfleet",
    summer: "Sommer",
    winter: "Winter",
    all_season: "All Season",
    promotions: "Aktionen",
    video_in_store: "Video mit Untertitel ",
    video_online: "Video ohne Untertitel",
    banner_website: "Banner",
    banner_social_media: "Social Media",
    logos: "Logos",
    b_drive: "B-drive",
    media_library: "Media library",
    media_packages: "Media packages",
  },
  placeholders: {
    searchMedia: "Suchbegriff eingeben",
  },
  searchResults: "Suchergebnisse",
  setFilters: "Setzen Sie bitte maximal einen Filter pro Spalte",
  kickbackExchange: {
    title: "Kickback-Austausch",
    description:
      "Bitte geben Sie den Betrag der Gebühr ein, die Sie umtauschen möchten<sup>*</sub>:",
    disclaimer: "Einstiegslevel: {tyres} Reifen erforderlich",
    afterExchange: "Ihr Punktesaldo nach dem Austausch:",
  },
  productSearchBox: {
    from: "ab Punktewert",
    to: "bis Punktewert",
  },
  validators: {
    min_money: "Field must be greater then {min} €",
    max_money: "Field must be lower then {max} €",
  },
  vouchers: {
    title: "Übersicht über Gutscheincodes",
    short_description:
      "Hier finden Sie eine Übersicht aller eingelösten Gutscheincodes.",
    table: {
      headers: {
        voucher: "Gutscheincode",
        company: "Unternehmen",
        street: "Straße",
        postcode: "Postleitzahl",
        location: "Ort",
        solved_at: "Einlösdatum",
        points: "Punkte durch den Code",
      },
    },
    exchange: {
      title: "Geben Sie Ihren Code ein, um Punkte zu erhalten",
      pointsLabel: "Geben Sie hier den Code ein:",
      result: "Anzahl der Punkte:",
    },
  },
  subMediaPage: {
    description:
      "Willkommen im Medienbereich rund um die Produkte von Bridgestone und Firestone. Hier finden Sie aktuelle Produktabbildungen, Logos sowie zahlreiche Banner, Videos und digitale Vorlagen für den Einsatz z. B. auf Ihrer Internetseite oder auf Social Media.",
  },
  brochure_prices: {
    description:
      "Laden Sie hier aktuellen Broschüren, Flyer und Preislisten zu unseren Bridgestone und Firestone Reifen für Pkw, SUV und Transporter herunter.",
  },
  brochureCategories: {
    products: "Produkte",
    brand_and_solutions: "Marke & Lösungen",
    season_and_promotions: "Saison & Aktionen",
    format: "Format",
    cars_and_vans: "Pkw & Transporter",
    summer: "Sommer",
    winter: "Winter",
    promotions: "Aktionen",
    all_season: "Ganzjahresreifen",
    truck_and_buses: "Lkw & Bus",
    motorcycle: "Motorrad",
    agriculture: "Landwirtschaft",
    construction_machinery: "Baumaschinen",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleet Care",
    webfleet: "Webfleet",
    material: "Materialien",
    brochures: "Produktbroschüren",
    price_list: "Preislisten",
    materials: "Materialien",
  },
  favoriteProducts: {
    description: "Hier finden Sie die von Ihnen gespeicherten Produkte.",
  },
  multiplicator: {
    title: "Bonus-Multiplikator",
    bandBonusTitle: "Bonus pro Reifen beim Multiplikator",
    amountLabel: "Min. Anzahl Reifen (*)",
    label: "Bonus-Multiplikator",
    desc: "Anzahl Bridgestone- und Firestone-Reifen. Es gibt keinen Bonus in Euro auf Firestone-Reifen.",
    goals: {
      loyal: "Loyal",
      bronze: "Bronze",
      silver: "Silber",
      gold: "Gold",
      platinum: "Platin",
    },
    andMore: "und mehr",
    chooseTarget: "Auswählen",
    selectTarget: "Wählen Sie hier Ihr Jahresziel {year} aus:",
    multiplication: "Bonus wird mit <b>{factor}</b> multipliziert",
    minTyres: "<b>Minimum:</b> {tyre} Reifen",
  },
  validation: {
    participantCount: {
      max: "{field} darf maximal {max} sein",
    },
    setPoints: {
      max: "Sie haben insgesamt {max} Punkte zur Verfügung",
    },
    default: "{field} darf maximal {max} sein",
  },
};
